import { Component, AfterViewInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-proforma-manage',
  templateUrl: './proforma-manage.component.html',
  styleUrls: ['./proforma-manage.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class ProformaManageComponent implements AfterViewInit {

  ngAfterViewInit(): void {

  }
}